export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/v8y4kf97mbpXnLzv9UYM85/Mock_up_Barber_Instructor_Ready_en_frances.png'
